import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataSourceDefinitionsService } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source-definitions/services/data-source-definitions.service';
import { NewDataSourceItemsService } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source-items/services/new-data-source-items.service';
import { ReferenceLookupService } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/references/services/reference-lookup-service.service';
import { UsersService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/users/services/users.service';
import { TourDialogComponent } from './tour-dialog/tour-dialog.component';

@Component({
  standalone: false,
  selector: 'app-private',
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.scss'],
})
export class PrivateComponent implements OnInit {
  constructor(
    private readonly dialog: MatDialog,
    private readonly userService: UsersService,
    private referenceLookupService: ReferenceLookupService,
    private dataSourceItemsService: NewDataSourceItemsService,
    private dataSourceDefinitionsService: DataSourceDefinitionsService,
  ) {}

  definitions;

  async ngOnInit() {
    const completedTour = localStorage.getItem('has-completed-initial-tour');

    // Tour is disabled for narrow screen (mobile) for now
    if (!completedTour && window.innerWidth > 600) {
      this.dialog.open(TourDialogComponent, {
        panelClass: 'custom-dialog-tour-background',
      });
      localStorage.setItem('has-completed-initial-tour', 'true');
    }
    await this.userService.loadUser();

    //Set up the reference providers //TODO : Consider if there is a better place to do this!
    this.initReferenceLookupService();
  }

  async initReferenceLookupService() {
    this.definitions = await this.dataSourceDefinitionsService.getAllDefinitions();

    this.definitions.forEach((definition) => {
      this.referenceLookupService.addReferenceProvider(
        definition.alias,
        definition,
        this.dataSourceItemsService,
      );
    });

    this.referenceLookupService.addReferenceProvider('*', null, this.dataSourceItemsService);
  }
}
